const SOCIAL_ABBR  = { facebook:'FB', instagram:'IG', twitter:'X', youtube:'YT', tiktok:'TT', whatsapp:'WA', linkedin:'LI' };
const SOCIAL_COLOR = { facebook:'#1877F2', instagram:'#E1306C', twitter:'#000', youtube:'#FF0000', tiktok:'#010101', whatsapp:'#25D366', linkedin:'#0A66C2' };

export default function FooterLight({ settings = {} }) {
  const { columns = [], copyright, style = {}, customHtml = '' } = settings;

  const bgColor = style.bgFrom ?? '#f9fafb';
  const copy    = copyright    ?? `© ${new Date().getFullYear()} KiddieJoy Store. All rights reserved.`;

  const brandCol = columns.find(c => c.type === 'brand');
  const linkCols = columns.filter(c => c.type === 'links');

  const socialLinks = brandCol?.props?.socialLinks ?? [];
  const logoType    = brandCol?.props?.logoType ?? 'text';
  const logoUrl     = brandCol?.props?.logoUrl  ?? '';
  const logoText    = brandCol?.props?.logoText ?? 'KiddieJoy';
  const tagline     = brandCol?.props?.tagline  ?? '';

  return (
    <footer style={{ backgroundColor: bgColor }} className="border-t border-gray-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Centered brand */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            {logoType === 'image' && logoUrl
              ? <img src={logoUrl} alt={logoText} className="h-12 w-auto object-contain" />
              : <span className="text-3xl font-black bg-gradient-to-r from-primary to-accent1 bg-clip-text text-transparent">{logoText}</span>
            }
          </div>
          {tagline && <p className="text-textLight max-w-md mx-auto">{tagline}</p>}

          {/* Social links */}
          {socialLinks.length > 0 && (
            <div className="flex justify-center gap-3 mt-6">
              {socialLinks.map(sl => (
                <a key={sl.id} href={sl.url || '#'} target="_blank" rel="noreferrer"
                  className="w-10 h-10 rounded-xl text-white text-xs font-bold flex items-center justify-center opacity-90 hover:opacity-100 transition-opacity"
                  style={{ backgroundColor: SOCIAL_COLOR[sl.platform] ?? '#555' }}>
                  {SOCIAL_ABBR[sl.platform] ?? '?'}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Link columns */}
        {linkCols.length > 0 && (
          <div className={`grid grid-cols-2 md:grid-cols-${Math.min(linkCols.length, 4)} gap-8 mb-12`}>
            {linkCols.map(col => (
              <div key={col.id} className="text-center">
                <h3 className="font-black text-textDark text-sm mb-4 uppercase tracking-wider">{col.props?.title || 'Links'}</h3>
                <ul className="space-y-2">
                  {(col.props?.links ?? []).map(l => (
                    <li key={l.id}><a href={l.url || '#'} className="text-textLight hover:text-primary transition-colors text-sm">{l.label}</a></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* HTML columns */}
        {columns.filter(c => c.type === 'html').map(col => (
          <div key={col.id} className="mb-8 text-center">
            {col.props?.title && <h3 className="font-black text-textDark text-sm mb-3 uppercase tracking-wider">{col.props.title}</h3>}
            {col.props?.html  && <div className="text-textLight" dangerouslySetInnerHTML={{ __html: col.props.html }} />}
          </div>
        ))}

        {customHtml && <div className="mb-8 text-center" dangerouslySetInnerHTML={{ __html: customHtml }} />}

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center text-textLight text-sm gap-4">
          <p>{copy}</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-primary transition-colors">Privacy</a>
            <a href="#" className="hover:text-primary transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
